import moment from "moment-timezone";
const timezone = 'Asia/Tokyo'

export const toDateString = (dateTimeString: string|undefined) => (
  dateTimeString ? moment(dateTimeString).tz(timezone).format('YYYY-MM-DD') : ''
)
